export default __webpack_public_path__ + "static/media/MAC.836c4e83.png";